import {
  FinancialPOAIntakeSchema,
  type FinancialPOAIntake,
} from '@bedside-docs/contracts';
import type { SafeParseReturnType } from 'zod';

export const parseFinancialPoaIntakeCandidate = (
  value: unknown,
): SafeParseReturnType<FinancialPOAIntake, FinancialPOAIntake> => {
  const direct = FinancialPOAIntakeSchema.safeParse(value);
  if (direct.success) {
    return direct;
  }

  if (value && typeof value === 'object') {
    const container = value as { intake?: unknown; data?: unknown };

    if (container.intake) {
      const nested = FinancialPOAIntakeSchema.safeParse(container.intake);
      if (nested.success) {
        return nested;
      }
    }

    if (container.data) {
      const nested = FinancialPOAIntakeSchema.safeParse(container.data);
      if (nested.success) {
        return nested;
      }
    }
  }

  return direct;
};
